import {GessanBaseAPI} from "@/api/gessan.base.api";
import {
  VUE_APP_API_AUTH_GESSAN_URL,
  API_URL_SERVICE
} from "@/commons/config";
import {AxiosObservable} from "axios-observable/dist/axios-observable.interface";
import {DadosAluno} from "@/models/sie-pedidos/dadosAluno";
import {User} from "@/models/user";
import {from} from "rxjs";
import axios from "axios";

export class AuthApi extends GessanBaseAPI<DadosAluno> {
  constructor() {
    super();
    this.apiUrl = VUE_APP_API_AUTH_GESSAN_URL;
  }
  public customAxios = axios.create();
  public signin (cnpj: string, token: string): AxiosObservable<User> {
    return this.axios.post(`${this.apiUrl}`, {cnpj, token} )
  };
  public siginCentral(cnpj: string){
    // @ts-ignore
    return from(
      this.customAxios.post(
        `${API_URL_SERVICE}/api/gessan/login`,
        { cnpj: cnpj },
        {
          responseType: "blob",
          headers: {
            Accept: "application/json",
          },
        }
      )
    );
  }
}
